import { useNavigation } from "@react-navigation/native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import useBaseRequest from "../../api/BaseRequest";
import { Register } from "@grassrootly/api";
import { RegisterDTO } from "./Register.types";
import { useAlert } from "@grassrootly/rn-core";

export function useRegister() {
  const insents = useSafeAreaInsets();
  const navigation = useNavigation();
  const { success } = useAlert();

  const goToLogin = () => {
    navigation.navigate("login");
  };

  const { execute, loading } = useBaseRequest(Register, {
    onCompleted: (data) => {
      if (!data) return;
      success({ title: "Account created", message: "Verification email has been sent, please check your inbox." });
      navigation.reset({ index: 0, routes: [{ name: "login" }] });
    },
  });

  const register = (payload: RegisterDTO) => {
    execute({ email: payload.email, name: payload.name, password: payload.password });
  };

  return { goToLogin, loading, register, insents };
}
